var map = {
	"./br/PT/S1/bg116.png": 48296,
	"./br/PT/bg116.png": 95836,
	"./in/EN/S1/bg116.png": 93603,
	"./in/EN/bg116.png": 36378,
	"./ph/EN/S1/bg116.png": 99048,
	"./ph/EN/bg116.png": 5644,
	"./vn/VI/S1/bg116.png": 6893,
	"./vn/VI/bg116.png": 43777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29890;